import clsx from "clsx";
import { useSelector } from "react-redux";

import Button from "@/components/common/button";
import { DeliveryTypes } from "~/types/cart";
// @ts-ignore
import { daysTextForm } from "~/utils";

import styles from "../index.module.scss";

export default function ShopsNew({ currentType, onBuy, canBuy, isShow }: any) {
  const { deliveryNew } = useSelector((state: any) => state.product);
  const { contactsData } = useSelector((state: any) => state.contacts);

  const getQty = (qty = 0, type = "empty") => {
    if (type === "empty") {
      return '<span style="color:red">Нет в наличии</span>';
    }
    if (type === "relocation") {
      return '<span style="color:red">Под заказ</span>';
    }
    if (qty < 5) {
      return "мало";
    }
    return "много";
  };

  return (
    isShow && (
      <div>
        <div className={styles.Table}>
          <span className={clsx(styles.TableFirst, styles.Head)}>
            Адреса магазинов
          </span>
          <span className={styles.Head}>Режим работы</span>
          <span className={styles.Head}>Наличие</span>
          <span className={styles.Head}>
            {currentType === DeliveryTypes.pickup && "Время самовывоза"}
          </span>
          <span className={styles.HeadLast} />
          {contactsData.SHOPS?.map((shop: any) => (
            <>
              <span className={styles.TableFirst}>{shop.NAME}</span>
              <span>
                <div className="muted">{shop.WORK_TIME}</div>
              </span>
              <span
                dangerouslySetInnerHTML={{
                  __html: getQty(
                    deliveryNew?.find(
                      (delivery: any) => delivery.id === shop.PROP_ID_NEW,
                    )?.availability,
                    deliveryNew?.find(
                      (delivery: any) => delivery.id === shop.PROP_ID_NEW,
                    )?.availabilityType,
                  ),
                }}
              />
              <span>
                {daysTextForm(
                  deliveryNew?.find(
                    (delivery: any) => delivery.id === shop.PROP_ID_NEW,
                  )?.days,
                )}
              </span>
              <span className={styles.TableButton}>
                {canBuy && (
                  <Button
                    label="Оформить покупку"
                    type="outline"
                    onClick={onBuy}
                  />
                )}
              </span>
            </>
          ))}
        </div>
      </div>
    )
  );
}
